module.exports = __webpack_public_path__ + "img/loading.854762d2.svg";